import { Modal, Box, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { modalStyles } from './styles';

interface ImageModalProps {
  open: boolean;
  currentIndex: number;
  images: Array<{ url: string }>;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
}

export const ImageModal = ({ open, currentIndex, images, onClose, onNext, onPrev }: ImageModalProps) => {
  if (!images.length) return null;

  return (
    <Modal open={open} onClose={onClose} sx={modalStyles.modal}>
      <Box sx={modalStyles.modalContainer}>
        <IconButton
          onClick={onClose}
          sx={[modalStyles.modalButton, modalStyles.closeButton]}
        >
          <CloseIcon />
        </IconButton>

        <IconButton
          onClick={onPrev}
          sx={[modalStyles.modalButton, modalStyles.navButton, modalStyles.prevButton]}
        >
          <ChevronLeft />
        </IconButton>

        <IconButton
          onClick={onNext}
          sx={[modalStyles.modalButton, modalStyles.navButton, modalStyles.nextButton]}
        >
          <ChevronRight />
        </IconButton>

        <Box
          component="img"
          src={images[currentIndex]?.url}
          alt={`Hotel image ${currentIndex + 1}`}
          sx={modalStyles.modalImage}
        />

        <Box sx={modalStyles.imageCounter}>
          <Typography variant="body1" fontWeight="medium">
            {currentIndex + 1} / {images.length}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};
